module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("贷款计算器")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.calc($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.amount = _vm.currency2number(_vm.amount)
      },
      "blur": function($event) {
        _vm.amount = _vm.number2currency(_vm.amount)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-text"
  }, [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    ref: "loanLifeInp",
    staticClass: "form-control loan-life-text",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.loanLife
    },
    on: {
      "change": _vm.setLoanLife
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loan-life"
  }, [_c('div', {
    staticClass: "loan-life-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loanLifeType),
      expression: "loanLifeType"
    }],
    attrs: {
      "type": "radio",
      "name": "loanLife",
      "checked": "checked"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.loanLifeType, 0)
    },
    on: {
      "__c": function($event) {
        _vm.loanLifeType = 0
      }
    }
  }), _c('span', [_vm._v("天")])]), _vm._v(" "), _c('div', {
    staticClass: "loan-life-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loanLifeType),
      expression: "loanLifeType"
    }],
    attrs: {
      "type": "radio",
      "name": "loanLife"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.loanLifeType, 1)
    },
    on: {
      "__c": function($event) {
        _vm.loanLifeType = 1
      }
    }
  }), _c('span', [_vm._v("月")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDay),
      expression: "startDay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "起息日，选填"
    },
    domProps: {
      "value": (_vm.startDay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDay = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-alias",
    on: {
      "click": _vm.showStartDatePicker
    }
  }), _vm._v(" "), _c('datePicker', {
    attrs: {
      "is-show": _vm.isShowStartDate
    },
    on: {
      "select-date": _vm.setStartDay
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDay),
      expression: "endDay"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "到期日，选填"
    },
    domProps: {
      "value": (_vm.endDay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDay = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-alias",
    on: {
      "click": _vm.showEndDatePicker
    }
  }), _vm._v(" "), _c('datePicker', {
    attrs: {
      "is-show": _vm.isShowEndDate
    },
    on: {
      "select-date": _vm.setEndDay
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "addon-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rateType),
      expression: "rateType",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "rateType",
      "checked": "checked"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.rateType, _vm._n(0))
    },
    on: {
      "__c": function($event) {
        _vm.rateType = _vm._n(0)
      }
    }
  }), _c('span', [_vm._v("年利率")])]), _vm._v(" "), _c('div', {
    staticClass: "addon-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rateType),
      expression: "rateType",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "rateType",
      "disabled": _vm.loanLifeType === 0
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.rateType, _vm._n(1))
    },
    on: {
      "__c": function($event) {
        _vm.rateType = _vm._n(1)
      }
    }
  }), _c('span', [_vm._v("月利率")])]), _vm._v(" "), _c('div', {
    staticClass: "addon-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rateType),
      expression: "rateType",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "name": "rateType",
      "disabled": _vm.loanLifeType === 1
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.rateType, _vm._n(2))
    },
    on: {
      "__c": function($event) {
        _vm.rateType = _vm._n(2)
      }
    }
  }), _c('span', [_vm._v("日利率")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rate-box"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loanRate),
      expression: "loanRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.loanRate)
    },
    on: {
      "change": function($event) {
        _vm.loanRate = _vm.calcRate(_vm.loanRate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loanRate = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-text"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serviceRate),
      expression: "serviceRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.serviceRate)
    },
    on: {
      "change": function($event) {
        _vm.serviceRate = _vm.calcRate(_vm.serviceRate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serviceRate = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-text"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherRate),
      expression: "otherRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.otherRate)
    },
    on: {
      "change": function($event) {
        _vm.otherRate = _vm.calcRate(_vm.otherRate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherRate = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-text"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-expansion iconfont",
    class: {
      expansion_open: _vm.isOpen
    },
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loanLifeType === 0),
      expression: "loanLifeType === 0"
    }],
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "addon-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDays),
      expression: "basicDays"
    }],
    attrs: {
      "type": "radio",
      "name": "basicDays",
      "checked": "checked"
    },
    domProps: {
      "value": 360,
      "checked": _vm._q(_vm.basicDays, 360)
    },
    on: {
      "__c": function($event) {
        _vm.basicDays = 360
      }
    }
  }), _c('span', [_vm._v("360天")])]), _vm._v(" "), _c('div', {
    staticClass: "addon-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.basicDays),
      expression: "basicDays"
    }],
    attrs: {
      "type": "radio",
      "name": "basicDays"
    },
    domProps: {
      "value": 365,
      "checked": _vm._q(_vm.basicDays, 365)
    },
    on: {
      "__c": function($event) {
        _vm.basicDays = 365
      }
    }
  }), _c('span', [_vm._v("365天")])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("利息总额")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "decimal"
  }, [_vm._v(_vm._s(_vm.getDecimal(_vm.totalInterest)))]), _vm._v(" 元")])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("还款总额")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "decimal"
  }, [_vm._v(_vm._s(_vm.getDecimal(_vm.totalPament)))]), _vm._v(" 元")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalService != 0),
      expression: "totalService != 0"
    }],
    staticClass: "list-item"
  }, [_c('span', [_vm._v("服务费用")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "decimal"
  }, [_vm._v(_vm._s(_vm.getDecimal(_vm.totalService)))]), _vm._v(" 元")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalOther != 0),
      expression: "totalOther != 0"
    }],
    staticClass: "list-item"
  }, [_c('span', [_vm._v("其他费用")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "decimal"
  }, [_vm._v(_vm._s(_vm.getDecimal(_vm.totalOther)))]), _vm._v(" 元")])])]), _vm._v(" "), _vm._m(11)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("贷款金额")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("贷款期限")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("起息日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("到期日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("利率类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("贷款利率")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("服务费率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("其他费率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-label"
  }, [_c('label', [_vm._v("基本天数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_c('label', {
    staticClass: "pament-label"
  }, [_vm._v("还款方式")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "pament-mode"
  }, [_vm._v("到期还本付息")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("计算")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instructions"
  }, [_c('h3', [_vm._v("使用说明")]), _vm._v(" "), _c('p', [_vm._v("本计算器分别以年利率或日利率（月利率）为基数进行计算以下举例均按基本天数360天为例。")]), _vm._v(" "), _c('p', [_vm._v("如按年利率计算：利息=贷款金额*年利率*期限/360")]), _vm._v(" "), _c('p', [_vm._v("按日利率计算：利息=贷款金额*日利率*期限")]), _vm._v(" "), _c('p', [_vm._v("以年利7%为例，日利率=7%/360=0.0195%，")]), _vm._v(" "), _c('p', [_vm._v("月利率=7%/12=0.5834%")]), _vm._v(" "), _c('p', [_vm._v("利息的计算结果保留至小数点后两位，小数点后第三位开始舍去。")]), _vm._v(" "), _c('p', [_vm._v("计算结果仅供参考。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ea99280!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discover/calculator-new.vue
// module id = 370
// module chunks = 1